/*
 * Prefer this to truthy filter to prevent problems with 0 and '' values
 */
export function isNotNullish<T>(value: null | undefined | T): value is T {
    return value !== null && value !== undefined;
}

export function isNullish<T>(value: null | undefined | T): value is null | undefined {
    return value === null || value === undefined;
}

export function checkNotNullish<T>(value: T, name: string): Exclude<T, null | undefined> {
    if (value === null || value === undefined) {
        throw new Error(`${name} is expected to be not nullish`);
    }
    return value as Exclude<T, null | undefined>;
}
